<section style="background-color: #ebf0f6; margin: 0px;padding: 0px;height: 100vh;width: 100%;">
    <div class="container content shadow p-3 mb-5 rounded">
        <form #checkout="ngForm" (ngSubmit)="onSubmit(checkout)" class="checkout">
            <div class="form-row">
                <div class="logo">
                    <img src="assets/images/iylonLogo.PNG" height="30px" width="50px">
                </div>
                <hr>
                <div class="detailsContainer">
                    <label for="card-info" style="font-size: 24px;opacity: 0.5;font-weight:400;float: left;">SUBMIT CARD
                        PAYMENT</label><br>
                    <label class="header">YOU ARE PAYING</label><span class="text">Iylon Precision Oncology</span>
                    <label class="header pt-3">PRODUCT</label><span
                        class="text">{{paymentData.productDetails.optedProduct}}</span>
                    <label class="header pt-3">AMOUNT</label><span class="text">$
                        {{paymentData.productDetails.amountToPay}}</span>
                </div>
                <div id="card-info" #cardInfo></div>
                <div id="card-errors" role="alert" *ngIf="error">{{ error }}</div>
            </div>

            <button type="submit" style="cursor: pointer;">Pay $ {{paymentData.productDetails.amountToPay}}</button>
        </form>

    </div>
</section>